export default "__VITE_ASSET__DnGTdAXM__"